const observer = new IntersectionObserver(
	(entries) => {
		entries.forEach((entry) => {
			if (entry.isIntersecting) {
				const target = entry.target;
				target.classList.add("active");
				observer.unobserve(target);
			}
		});
	},
	{ root: null, threshold: 0.7 }
);

const targets = document.querySelectorAll(".timeline-step");

targets.forEach((target) => {
	observer.observe(target);
});
